
<template>
  <div class="qr-code-container">
    <QRCodeVue :value="qrCodeUrl" :size="50" level="H"></QRCodeVue> <!-- 增大 size 的值 -->
  </div>
</template>

<script>
import VueQRCode from 'vue-qrcode';

export default {
  name: "QRCodeComponent",
  components: {
    QRCodeVue: VueQRCode
  },
  data() {
    return {
      qrCodeUrl: ' https://www.siab.org.cn:5858/RegisterPage'
    }
  }
}
</script>

<style scoped>
.qr-code-container {
  width: 50px; /* 设置容器的宽度与 size 属性一致 */
  height: 50px; /* 设置容器的高度与 size 属性一致 */
  display: flex;
  /*justify-content: center;*/
  /*align-items: center;*/
}
</style>